/**
 * Narrows an option's values to the ones the form is allowed to render.
 *
 * @param {boolean} selectedIsHidden - The chosen variant is hidden from the PDP
 *   (discontinued): the form freezes on that value rather than offering others.
 * @returns {Array} The values in their original order.
 */
export default function displayableOptionValues({
  optionValues,
  selectedOptionValue,
  selectedIsHidden,
}) {
  return optionValues.filter((optionValue) => {
    if (selectedIsHidden) {
      return optionValue.name === selectedOptionValue;
    }

    return !optionValue.allMatchingVariantsHidden;
  });
}
